import { render, staticRenderFns } from "./SelectWares.vue?vue&type=template&id=49a73be0&scoped=true&"
import script from "./SelectWares.vue?vue&type=script&lang=js&"
export * from "./SelectWares.vue?vue&type=script&lang=js&"
import style0 from "./SelectWares.vue?vue&type=style&index=0&id=49a73be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a73be0",
  null
  
)

export default component.exports